import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment-jalaali";
import { Form, Input, Spin, Col, Card, Space, Button, Row, Table } from 'antd';
import StringHelper from '../helpers/StringHelper';
import { ZoomInOutlined } from "@ant-design/icons";
import CrmReport from "./crmReport/CrmReport";
import strings from '../../utils/strings';
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../store/slices/createReportsSlice";
import { PlusOutlined } from '@ant-design/icons';
import CrmNewUser from './CrmNewUser';
import OnlyNumber from "../shared/OnlyNumbers";

export default function UsersBusinessReport() {
    const reports = useReportsStore()
    const general = useGeneralStore();
    const [form] = Form.useForm();
    const { search } = useLocation();
    const users = reports.userSearch.data.Items;
    const loading = reports.userSearch.loading;
    const [mob, setMob] = useState("");
    const [usrUserID, setUsrUserID] = useState();
    const [requesReportId, setRequestReportId] = useState(false);

    useEffect(() => {
        const number = new URLSearchParams(search).get("mobileNumber");
        if (number && StringHelper.isPhone(number)) {
            form.setFieldsValue({ mob: number });
            setMob(number);
            reports.getUserBusiness({ mobile: number });
        }
        else form.resetFields();

        return () => {
            reports.GetUserBusinessSuccess([])
        }
    }, []);


    function onFinish() {
        const mobileNum = strings.getEnglishNum(mob);
        if (!StringHelper.isPhoneStarter(mobileNum)) {
            general.NotifError("لطفا شماره موبایل معتبر وارد کنید");
            return;
        }
        reports.getUserBusiness({ mobile: mobileNum });
    }
    const columns = [
        {
            title: "جزئیات",
            dataIndex: "operation",
            key: "operation",
            width: 100,
            render: (_, request) =>

                <Space size="middle">
                    <Button
                        type="link"
                        onClick={() => {
                            setUsrUserID(request.UsrUserID);
                            // reports.getCrmRequestReport(request.UsrUserID);
                            setRequestReportId(true)
                            general.ToggleCrmReportModal(true);
                            reports.getCrmRequestReport({
                                usrUserID: request.UsrUserID,
                                PageSize: 10,
                                PageNumber: 1,
                                CategoryPaymentStatus: 1,

                            })

                        }}
                        size="small" ><ZoomInOutlined />
                    </Button>
                </Space>

        },
        {
            title: "نام بیزینس",
            dataIndex: "BusinessName",
            key: "BusinessName",
            width: 100,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.BusinessName ? (first = a.BusinessName) : (first = "");
                b.BusinessName ? (second = b.BusinessName) : (second = "");
                return first.localeCompare(second);
            },

            render: text => text && strings.getFarsiNum(text),
        },
        {
            title: "نام کاربری",
            dataIndex: "UserName",
            key: "UserName",
            width: 100,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.UserName ? (first = a.UserName) : (first = "");
                b.UserName ? (second = b.UserName) : (second = "");
                return first.localeCompare(second);
            },


        },
        {
            title: "نام و نام‌خانوادگی",
            dataIndex: "FullName",
            key: "FullName",
            width: 100,
        },
        {
            title: "نام پدر",
            dataIndex: "FatherName",
            key: "FatherName",
            width: 100,
        },
        {
            title: "کد ملی",
            dataIndex: "NationalCode",
            key: "NationalCode",
            width: 100,
        },
        {
            title: "تاریخ آخرین لاگین",
            dataIndex: "LastUsed",
            key: "LastUsed",
            width: 270,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.LastUsed ? first = a.LastUsed : first = '';
                b.LastUsed ? second = b.LastUsed : second = '';
                return first.localeCompare(second)
            },
            render: data => strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD  ساعت:  HH:mm'))
        },
        {
            title: "نقش كاربر",
            dataIndex: "RoleNames",
            key: "RoleNames",
            width: 100,
        },

        {
            title: "شماره شبا",
            dataIndex: "IBAN",
            key: "IBAN",
            width: 100,
        },

        {
            title: "شماره کارت",
            dataIndex: "BankCardNumber",
            key: "BankCardNumber",
            width: 100,
        },
        {
            title: "شماره حساب",
            dataIndex: "BankAccountNumber",
            key: "BankAccountNumber",
            width: 85,
        },
        {
            title: "نام بانک",
            dataIndex: "Bank",
            key: "Bank",
            width: 100,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.Bank ? (first = a.Bank) : (first = "");
                b.Bank ? (second = b.Bank) : (second = "");
                return first.localeCompare(second);
            },

            render: text => text && strings.getFarsiNum(text),
        },
        {
            title: "آدرس ایمیل",
            dataIndex: "Email",
            key: "Email",
            width: 100,
        },

    ];

    return (

        <>
            <Row>
                <Col span={24}>
                    <Card className="user-report-form" >
                        <Form
                            layout="inline" onFinish={onFinish}>
                            <Col span={16} style={{display:"flex",flexWrap:"nowrap"}}>
                                <Form.Item
                                    label="شماره تلفن همراه">
                                    <Input type="tel" onKeyPress={e => OnlyNumber(e)} maxLength={11} name="mob"
                                        style={{ minWidth: 100, height: "40px" }} value={mob}
                                        onChange={e => setMob(e.target.value)}
                                        onPressEnter={() => {
                                            const mobileNum = strings.getEnglishNum(mob);
                                            if (!StringHelper.isPhone(mobileNum)) {
                                                general.NotifError("لطفا شماره موبایل معتبر وارد کنید");
                                                return;
                                            }
                                            reports.getUserBusiness({ mobile: mobileNum });
                                        }} />
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="" colon={false} >
                                    <button
                                        disabled={loading} type="primary" style={{ fontSize: "14px" }}
                                        className="btn btn-primary waves-effect waves-light" htmltype="submit">جستجو&nbsp;&nbsp;&nbsp;
                                        <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                                    </button>
                                </Form.Item>
                            </Col>
                            <Col span={2}>
                                <button
                                    onClick={() => { general.ToggleCrmNewUserModal(true); }}
                                    disabled={loading} type="button" style={{ fontSize: "14px", height: "38px" }}
                                    className="btn btn-primary waves-effect waves-light crm-new-user-button">
                                    <PlusOutlined />
                                </button>
                            </Col>
                        </Form>
                        <CrmNewUser mobileNumber={mob} />
                        <CrmReport usrUserID={usrUserID} requesReportId={requesReportId} />
                    </Card >
                </Col>
            </Row>
            <Spin style={{ marginTop: "10px" }} spinning={loading}>
                {users && users.length > 0 &&
                    <Card>
                        <Table
                            style={{ overflowX: 'scroll' }}
                            size="small"
                            className="custom-table"
                            bordered
                            loading={loading}
                            rowKey="ID"
                            scroll={true}
                            dataSource={users}
                            columns={columns} />
                    </Card>}
            </Spin >
        </>
    )
}